const STORAGE_KEY = 'demohub_chat';

export const CURRENT_USER = {
  id: 'user1',
  name: 'You',
  avatar: '🧑‍💻',
  status: 'online',
};

export const CONTACTS = [
  { id: 'user2', name: 'Sarah Chen', avatar: '👩‍🎨', status: 'online', role: 'UI Designer' },
  { id: 'user3', name: 'Alex Rivera', avatar: '👨‍💻', status: 'online', role: 'Backend Dev' },
  { id: 'user4', name: 'Maya Patel', avatar: '👩‍💼', status: 'away', role: 'Product Manager' },
  { id: 'user5', name: 'James Wilson', avatar: '🧑‍🔬', status: 'offline', role: 'Data Scientist' },
  { id: 'user6', name: 'Emma Thompson', avatar: '👩‍🏫', status: 'online', role: 'Tech Lead' },
  { id: 'user7', name: 'David Kim', avatar: '👨‍🎤', status: 'away', role: 'DevOps Engineer' },
  { id: 'group1', name: 'Design Team', avatar: '🎨', status: 'online', role: 'Group · 5 members', isGroup: true },
  { id: 'group2', name: 'Project Alpha', avatar: '🚀', status: 'online', role: 'Group · 8 members', isGroup: true },
];

const AUTO_REPLIES = {
  user2: [
    "I'll have the mockups ready by end of day! 🎨",
    "Sure, let me check the design system for that.",
    "Great idea! I think we should use a card-based layout.",
    "The color palette looks amazing, don't you think?",
    "I just pushed the updated Figma file. Check it out!",
    "Let me know if you need any design assets.",
  ],
  user3: [
    "The API endpoint is ready. Just deployed to staging. 🚀",
    "Good catch! I'll fix that bug right away.",
    "I think we should use Redis for caching here.",
    "PR is up for review. Can you take a look?",
    "The database migration went smoothly!",
    "Let me write some unit tests for that.",
  ],
  user4: [
    "I've updated the sprint board with the new priorities.",
    "The client loved the demo! Great work everyone! 🎉",
    "Can we schedule a quick sync for tomorrow?",
    "The deadline has been moved to next Friday.",
    "I'll share the meeting notes in the channel.",
    "Let's discuss this in the standup tomorrow.",
  ],
  user5: [
    "The ML model accuracy improved to 94.5%! 📊",
    "I'll need more training data for this feature.",
    "The A/B test results are looking promising.",
    "Let me run the analysis and get back to you.",
    "The data pipeline is processing the new batch now.",
    "Interesting findings in the user behavior data!",
  ],
  user6: [
    "Let's do a code review session this afternoon.",
    "I think we should refactor this module before adding more features.",
    "Good approach! Ship it. ✅",
    "Can you document the architecture decisions?",
    "The performance benchmarks look solid.",
    "Let's pair program on this one.",
  ],
  user7: [
    "CI/CD pipeline is green across all environments! ✅",
    "I've set up monitoring for the new service.",
    "The Kubernetes cluster has been scaled up.",
    "Deployment to production completed successfully!",
    "Let me check the logs for that error.",
    "Infrastructure costs are down 15% this month!",
  ],
  group1: [
    "Has anyone seen the new design trends for 2026?",
    "The component library update is ready for review.",
    "Let's finalize the icon set today.",
    "New brand guidelines have been shared in the drive.",
  ],
  group2: [
    "Sprint review is at 3pm. Don't forget!",
    "The feature flag for v2 has been enabled on staging.",
    "QA found 2 minor issues. Nothing blocking.",
    "Great progress this week, team! 💪",
  ],
};

const now = Date.now();

const defaultConversations = {
  user2: {
    messages: [
      { id: 'm1', senderId: 'user2', text: "Hey! Have you seen the new dashboard design?", timestamp: now - 3600000 * 4, status: 'read' },
      { id: 'm2', senderId: 'user1', text: "Not yet! Can you share the Figma link?", timestamp: now - 3600000 * 3.5, status: 'read' },
      { id: 'm3', senderId: 'user2', text: "Sure! Here's what I've been working on. The new sidebar navigation is much cleaner.", timestamp: now - 3600000 * 3, status: 'read' },
      { id: 'm4', senderId: 'user1', text: "This looks incredible! 🔥 Love the color scheme", timestamp: now - 3600000 * 2.5, status: 'read' },
      { id: 'm5', senderId: 'user2', text: "Thanks! I'm also working on the mobile responsive version. Should be done by tomorrow.", timestamp: now - 3600000 * 2, status: 'read' },
      { id: 'm6', senderId: 'user1', text: "Perfect. Let me know if you need any help with the frontend implementation.", timestamp: now - 3600000, status: 'delivered' },
    ],
    typing: false,
    unread: 0,
  },
  user3: {
    messages: [
      { id: 'm7', senderId: 'user3', text: "The REST API is ready. I've added pagination support too.", timestamp: now - 7200000, status: 'read' },
      { id: 'm8', senderId: 'user1', text: "Awesome! What's the rate limit?", timestamp: now - 7000000, status: 'read' },
      { id: 'm9', senderId: 'user3', text: "100 requests per minute per user. We can adjust if needed.", timestamp: now - 6800000, status: 'read' },
      { id: 'm10', senderId: 'user3', text: "Also, I've set up WebSocket support for real-time updates 🔌", timestamp: now - 5400000, status: 'read' },
    ],
    typing: false,
    unread: 1,
  },
  user4: {
    messages: [
      { id: 'm11', senderId: 'user4', text: "Quick update — the client approved the proposal! 🎉", timestamp: now - 86400000, status: 'read' },
      { id: 'm12', senderId: 'user1', text: "That's fantastic news! When do we start?", timestamp: now - 85000000, status: 'read' },
      { id: 'm13', senderId: 'user4', text: "Kickoff meeting is scheduled for Monday at 10am.", timestamp: now - 84000000, status: 'read' },
    ],
    typing: false,
    unread: 0,
  },
  user5: {
    messages: [
      { id: 'm14', senderId: 'user5', text: "The recommendation engine is showing 30% improvement in CTR!", timestamp: now - 172800000, status: 'read' },
      { id: 'm15', senderId: 'user1', text: "Wow, that's a huge jump. What changed?", timestamp: now - 170000000, status: 'read' },
      { id: 'm16', senderId: 'user5', text: "We switched to a transformer-based model and added collaborative filtering.", timestamp: now - 168000000, status: 'read' },
    ],
    typing: false,
    unread: 0,
  },
  user6: {
    messages: [
      { id: 'm17', senderId: 'user6', text: "I've reviewed the PR. Just a few minor comments.", timestamp: now - 10800000, status: 'read' },
      { id: 'm18', senderId: 'user1', text: "Thanks! I'll address them now.", timestamp: now - 9000000, status: 'read' },
      { id: 'm19', senderId: 'user6', text: "Also, great work on the error handling. Very clean.", timestamp: now - 7200000, status: 'read' },
    ],
    typing: false,
    unread: 0,
  },
  user7: {
    messages: [
      { id: 'm20', senderId: 'user7', text: "Heads up — scheduled maintenance tonight at 11pm EST.", timestamp: now - 43200000, status: 'read' },
      { id: 'm21', senderId: 'user1', text: "Got it. How long will it take?", timestamp: now - 42000000, status: 'read' },
      { id: 'm22', senderId: 'user7', text: "About 30 minutes. Just upgrading the database cluster.", timestamp: now - 41000000, status: 'read' },
    ],
    typing: false,
    unread: 0,
  },
  group1: {
    messages: [
      { id: 'm23', senderId: 'user2', text: "Team, I've updated the design system with new components.", timestamp: now - 14400000, status: 'read' },
      { id: 'm24', senderId: 'user6', text: "Looks great! Let's discuss in our sync.", timestamp: now - 12000000, status: 'read' },
      { id: 'm25', senderId: 'user1', text: "I can help implement the new button variants.", timestamp: now - 10000000, status: 'read' },
    ],
    typing: false,
    unread: 0,
  },
  group2: {
    messages: [
      { id: 'm26', senderId: 'user4', text: "Sprint planning is done. Check the board for your tasks.", timestamp: now - 28800000, status: 'read' },
      { id: 'm27', senderId: 'user3', text: "I'll pick up the API migration task.", timestamp: now - 26000000, status: 'read' },
      { id: 'm28', senderId: 'user5', text: "I'll handle the data pipeline optimization.", timestamp: now - 24000000, status: 'read' },
      { id: 'm29', senderId: 'user1', text: "I'll take the frontend dashboard tickets.", timestamp: now - 22000000, status: 'read' },
    ],
    typing: false,
    unread: 2,
  },
};

export function getAutoReply(contactId) {
  const replies = AUTO_REPLIES[contactId];
  if (!replies) return "Thanks for your message!";
  return replies[Math.floor(Math.random() * replies.length)];
}

export function loadConversations() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) {
    console.error('Failed to load conversations:', e);
  }
  return defaultConversations;
}

export function saveConversations(conversations) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(conversations));
  } catch (e) {
    console.error('Failed to save conversations:', e);
  }
}

export function formatTime(timestamp) {
  const date = new Date(timestamp);
  const now2 = new Date();
  const diffDays = Math.floor((now2 - date) / 86400000);

  if (diffDays === 0) {
    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  } else if (diffDays === 1) {
    return 'Yesterday';
  } else if (diffDays < 7) {
    return date.toLocaleDateString('en-US', { weekday: 'short' });
  }
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatMessageTime(timestamp) {
  return new Date(timestamp).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}
